import Image from "next/image";
import { mappedImage } from "../CommonForm/CommonFormInterface";
import { memo } from "react";

const MappedImage = ({ field, data }: { field: mappedImage; data: any }) => {
  return (
    <>
      <div
        style={{
          ...field?.style,
        }}
      >
        <Image
          alt={field?.mapping[data]?.alt ?? "default alt"}
          src={
            (field?.baseUrl
              ? field?.baseUrl
              : process.env.NEXT_PUBLIC_IMAGE_BASE_URL) +
            (field?.mapping[data]?.src ?? "/product.webp")
          }
          height={parseFloat(
            field?.style?.height ? field?.style?.height?.toString() : "0"
          )}
          width={parseFloat(
            field?.style?.width ? field?.style?.width?.toString() : "0"
          )}
          onError={(e) => null}
          style={{
            height: "100%",
            width: "100%",
            maxHeight: "auto",
            maxWidth: "auto",
          }}
          priority={field.priority}
        />
      </div>
    </>
  );
};

export default memo(MappedImage);
